<template>
    <CostableTableRow
        v-if="isEditable"
        class="position-relative pointer"
        :is-heading-row="true"
        @click="addNewCost"
    >
        <template v-slot:heading>
            <span class="text-muted font-italic">
                Add another item...
            </span>
        </template>
    </CostableTableRow>
</template>

<script>
import CostableTableRow from '@/modules/costable/_components/CostableTableRow';

export default {
    components: { CostableTableRow },
    props: {
        groupId: {
            type: Number,
            default: null,
        },
    },

    computed: {
        isEditable() {
            return this.$store.getters['costable/isEditable'];
        },
    },

    methods: {
        addNewCost() {
            this.$store.dispatch('costable/storeCostWithoutBuildingCost', {
                group_id: this.groupId,
                original_quantity: 1,
            });
        },
    },

};
</script>

<style lang="scss" scoped>
.pointer {
    cursor: pointer;
}
</style>
